import type { ReactNode } from "react"
import { Link } from "react-router-dom"
import { PageEmpty, PageHeader } from "@/components/page"

interface NoActiveTeamEmptyProps {
  heading: string
  /** Ya no se muestra: el estado vacío sin caja no lleva icono. Se conserva por compatibilidad con los llamadores. */
  icon?: ReactNode
  description: ReactNode
  /** Muestra los accesos a competidores y cursos de preparación. */
  withActions?: boolean
}

/** Estado vacío compartido de las páginas CCCD cuando el estudiante no tiene equipo activo. */
export function NoActiveTeamEmpty({ heading, description, withActions = false }: NoActiveTeamEmptyProps) {
  return (
    <div className="space-y-6">
      <PageHeader title={heading} />
      <PageEmpty
        variant="ruled"
        title="Aún no tienes un equipo activo"
        description={description}
        action={
          withActions ? (
            <>
              <Link to="/cccd/competidores" className="inline-flex h-11 items-center justify-center rounded-lg bg-primary px-5 text-sm font-semibold text-primary-foreground hover:brightness-95 focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50">
                Ver equipos competidores
              </Link>
              <Link to="/courses" className="inline-flex h-11 items-center justify-center rounded-lg border border-border px-5 text-sm font-medium text-foreground hover:bg-accent focus-visible:outline-none focus-visible:ring-3 focus-visible:ring-ring/50">
                Explorar cursos de preparación
              </Link>
            </>
          ) : undefined
        }
      />
    </div>
  )
}
